/** IDs canônicos de tipo_evento do db_dfe. Não são códigos SEFAZ. */
export enum TipoEventoNFeEnum {
  Cancelamento = 1,
  ConfirmacaoOperacao = 4,
  CienciaEmissao = 5,
  DesconhecimentoOperacao = 6,
  OperacaoNaoRealizada = 7,
}
